import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setUserNameForSearch, setUserSurnameForSearch, setUserStatusForSearch, setUserIdForSearch, clearUserNameForSearch,
			clearUserSurnameForSearch, clearUserIdForSearch, setUserSortByField } from '../actions/localStates'

import i18next from 'i18next'

class UserSearchView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	statusValues: ["ACTIVE", "BLOCKED", "ACTIVE_BLOKED"]
	    }

	    this.onUserNameChanged = this.onUserNameChanged.bind(this);
	    this.onUserSecondnameChanged = this.onUserSecondnameChanged.bind(this);
		this.onUserStatusChanged = this.onUserStatusChanged.bind(this);
		this.onUserIdChanged = this.onUserIdChanged.bind(this);
		this.cleanUp = this.cleanUp.bind(this);

		this.handleSearchKeyUp = this.keyUpHandler.bind(this, 'Search');
	}

	componentDidMount() {
		
	}

	keyUpHandler(refName, e) {
        if (e.keyCode === 13) {
    		document.getElementById("search").click();
       		document.activeElement.blur()
        }
    }

	cleanUp() {
		this.props.actions.clearUserNameForSearch()
		this.props.actions.clearUserSurnameForSearch()
		this.props.actions.clearUserIdForSearch()
		this.props.actions.setUserStatusForSearch("")
		this.props.actions.setUserSortByField("")

		this.props.refresh()
	}

	searchUser() {
		this.props.searchUser()
	}

	onUserNameChanged (e) {
		this.props.actions.setUserNameForSearch(e.target.value)
	}

	onUserSecondnameChanged (e) {
		this.props.actions.setUserSurnameForSearch(e.target.value)
	}

	onUserStatusChanged (e) {
		if (e.target.value === "ACTIVE_BLOKED") {
			this.props.actions.setUserStatusForSearch("")
		} else {
			this.props.actions.setUserStatusForSearch(e.target.value)
		}
	}

	onUserIdChanged (e) {
		this.props.actions.setUserIdForSearch(e.target.value)
	}

	render() {
		return (
			<div className="col-12" style={{padding: "0px"}}>
				<div className="row col-12" style={{padding: "0px"}}>
					<div className="col-6">
						<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("surnameLabel")}</label>
						<input className="form-control" type="text" value={this.props.search.userSurname} onChange={this.onUserSecondnameChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
					</div>

					<div className="col-6">
						<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("nameLabel")}</label>
						<input className="form-control" type="text" value={this.props.search.userName} onChange={this.onUserNameChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
					</div>
					
					<div className="col-6">
						<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("statusLabel")}</label>
						<div>
							<select type="select" className="form-control" style={{textAlign: "center", textAlignLast: "center"}} onChange={this.onUserStatusChanged}>
                                {
                                  this.state.statusValues.map((value, index) =>
                                    <option key={index} value={value} selected={this.props.search.userStatus === "" ? true : (this.props.search.userStatus === value) ? true : false}>{i18next.t(value)}</option>)
                                }          
                            </select>
						</div>
					</div>
					<div className="col-6">
						<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("uniqueIdLabel")}</label>
						<input className="form-control" type="text" value={this.props.search.userId} onChange={this.onUserIdChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
					</div>
				</div>
				<div style={{float: "right", marginRight: "15px", marginTop: "10px"}}>
					<button id="search" className="btn btn-info" onClick={this.searchUser.bind(this)}>{i18next.t("searchLabel")}</button>&nbsp;
					<button className="btn btn-outline-info" onClick={this.cleanUp}>{i18next.t("cleanUpLabel")}</button>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        search: state.userSearchReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setUserNameForSearch,
		setUserSurnameForSearch,
		setUserStatusForSearch,
		setUserIdForSearch,
		clearUserNameForSearch,
		clearUserSurnameForSearch, clearUserIdForSearch,
		setUserSortByField
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSearchView);